(function(){
    angular.module('tmx-app').factory('OrganizationsService', ['tmxResource','$mdMedia',
        function(tmxResource,$mdMedia){


            // var organizationVM = tmxResource("Corporate0Detail","http://smart-advance-poc.azurewebsites.net/api/api/v1/");
            var organizationVM = tmxResource("Organization");
        organizationVM.status = [
            { LookupId: "active",
                VisibleValue: "Active"
            },
            { LookupId: "inactive",
                VisibleValue: "Inactive"
            }
        ];

        
        organizationVM.ChangeLimit = ChangeLimit;
        function ChangeLimit(requestData){
            return organizationVM.getByAction("ChangeLimit?CompanyId="+requestData.CompanyId+ "&TotalCreditLimit=" + requestData.TotalCreditLimit ,true,"put");
        }

        organizationVM.Columns=[
            {
                field: "OrganizationName",
                title:  "OrganizationName",
                type: "text",
                maxlength:"30",
                minlength:"3",                
                scrollable: false,
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : OrganizationsCtrl.isFiltered('OrganizationName')}\" >{{' Name'|translate}} <i class='fa fa-filter' ng-if='OrganizationsCtrl.isFiltered(\"OrganizationName\")' ></i></span>",
               template: "<md-button ng-disabled='!OrganizationsCtrl.editPermission' class='tmx-primary-text-grid' ng-click='OrganizationsCtrl.clickEdit(dataItem)'> #=OrganizationName#  </md-button>",
            },
            {
                field: "OrganizationIdentificationNumber",
                title:  "OrganizationIdentificationNumber",
                type: "text",
                maxlength:"30",
                minlength:"3",                
                scrollable: false,
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : OrganizationsCtrl.isFiltered('OrganizationIdentificationNumber')}\" >{{'Identification Number'|translate}} <i class='fa fa-filter' ng-if='OrganizationsCtrl.isFiltered(\"OrganizationIdentificationNumber\")' ></i></span>"

            },
            {
                field: "OrganizationCode",
                title:  "Organization Code",
                type: "text",
                maxlength:"30",
                minlength:"3",                
                scrollable: false,
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : OrganizationsCtrl.isFiltered('OrganizationCode')}\" >{{'Code'|translate}} <i class='fa fa-filter' ng-if='OrganizationsCtrl.isFiltered(\"OrganizationCode\")' ></i></span>"

            },
            {
                field: "Persons",
                title:  "Persons",
                type: "integer",
                maxlength:"30",
                minlength:"1",                
                scrollable: false,
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : OrganizationsCtrl.isFiltered('Persons')}\" >{{'Persons'|translate}} <i class='fa fa-filter' ng-if='OrganizationsCtrl.isFiltered(\"Persons\")' ></i></span>"

            },
            {
                command: []
            }
            
        ];
        //functions
        organizationVM.getorganizationVMByCompany=getorganizationVMByCompany;
        organizationVM.getorganizationVMummary =getorganizationVMummary;
        organizationVM.checkDistributorCode=checkDistributorCode;
        organizationVM.getorganizationVMByLocationId=getorganizationVMByLocationId;
        organizationVM.organizationVM=organizationVM;
        organizationVM.getLovs=getLovs;
        organizationVM.getDistributorTypeLookups=getDistributorTypeLookups;
        organizationVM.getStatusLookups=getStatusLookups;
        organizationVM.getorganizationVMOfLoginUser=getorganizationVMOfLoginUser;
        organizationVM.getUnitByLocationId=getUnitByLocationId;
        organizationVM.geDetailsByCIF=geDetailsByCIF;
        organizationVM.getCompanySummary=getCompanySummary;
        organizationVM.getEmployers = getEmployers;
        organizationVM.getEmployerById = getEmployerById;
        organizationVM.CreateEmployer =CreateEmployer;
        organizationVM.getAllOrganizations = getAllOrganizations;



        function geDetailsByCIF(id) {
            return organizationVM.getByAction('GetCoporateDetail/' + id,false);
          }

          function getCompanySummary(id) {
            return organizationVM.getByAction('GetCompanySummary/' + id);
          }
  

        function getorganizationVMByCompany(companyId) {
          return organizationVM.getByAction('GetUnitByCompany/' + companyId,true);
        }

        function getorganizationVMummary(id) {
          return organizationVM.getByAction('GetUnitSummary/' + id);
        }

        function checkDistributorCode(id){
            return organizationVM.getById("CheckCode/"+id);
        }
        function getEmployerById(id){
            return organizationVM.getByAction("GetEmployer/"+id);
        }
        function getorganizationVMByLocationId(id) {
            return organizationVM.getByAction('GetUnitByLocation/' + id, true);
        }

        function getUnitByLocationId() {
            return organizationVM.getByAction('GetUnitByUser/' , true);
        }

        

        function getLovs(){

            return organizationVM.lov();
        }

        function getorganizationVMByLocation() {

            return organizationVM.getByAction('GetUnitsByLocation', true, 'get');

        }

        function getorganizationVMOfLoginUser(){
           return organizationVM.getByAction('GetUnitsOfLoggedInUser',true);
        }

        function getStatusLookups(){

            var Lookup=tmxResource("Lookup");
            return  Lookup.getByAction("GetByLookupType/DISTRIBUTOR_STATUS",true,"get");
        }

        function getDistributorTypeLookups(){

            var Lookup=tmxResource("Lookup");
            return  Lookup.getByAction("GetByLookupType/DISTRIBUTOR_TYPE_LKP",true,"get");
        }
        function getEmployers(param){
            return organizationVM.getByAction('GetEmployerList/'+param, true, 'get');
        }
        function CreateEmployer(param){
            return organizationVM.getByAction("CreateEmployer" ,false,"post",param);
        }
        function getAllOrganizations(){
            return organizationVM.all();
        }
        return organizationVM;


    }]);
})();
